import type { FaireProductEntity } from "../../entity_types/product";

export const p_bsycanw1f9: FaireProductEntity = {
  token: "p_bsycanw1f9",
  type: "product",
  name: "Sunny Day Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9e3de12c09e99bb8e8c6843f83158853befa9f57b19cfb6192b1c7a3bd22bde3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d93f614f66adc3099e477f2d7a132be9348fcc32896f772b9795aa5629d0317.jpeg",
    "https://cdn.faire.com/fastly/71ea1f31b825c44f1e0b3545fc12b7be755475da0685e266fc9b108264ccf7b8.jpeg",
    "https://cdn.faire.com/fastly/6c4c0359870c704501629d1f506388e6573eae9536adb5d95ac7769a6dd28bc1.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:43.673Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
